export const examData = {
  bright: {
    name: 'BRIGHT',
    displayName: {
      text: 'Bright Language',
      trademark: true
    },
    shortName: {
      text: 'Bright',
      trademark: false
    },
    numberOfExams: 12,
    score: {
      min: 0.5,
      max: 5,
      step: 0.5,
      nbAnswers: false
    },
    playlistAudio: false,
    part: {
      sections: [
        {
          title: 'Oral',
          id: 'listening',
          parts: [
            {
              id: 1,
              title: 'Oral test',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Questions take one of the following formats:<br>• Interpret the meaning of a phrase,<br>• Choose the word/phrase that best fits in the space,<br>• Choose the phrase which is a valid expression,<br>• Choose a picture which best interprets the context of a phrase, or<br>• Choose the best response to a given phrase.',
              directionText:
                'Questions take one of the following formats: interpret the meaning of a phrase, choose the word/phrase that best fits in the space, choose the phrase which is a valid expression, choose a picture which best interprets the context of a phrase, or choose the best response to a given phrase.',
              hasTips: false,
              timer: 60
            }
          ],
          audio: {
            isPlaylist: false
          },
          timer: {
            isGlobal: false
          }
        },
        {
          title: 'Écrit',
          id: 'reading',
          parts: [
            {
              id: 2,
              title: 'Written test',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'Questions take one of the following formats:<br>• Interpret the meaning of a phrase,<br>• Choose the word/phrase that best fits in the space,<br>• Choose the phrase which is a valid expression,<br>• Choose the best response to a given phrase.',
              directionText:
                'Questions take one of the following formats: interpret the meaning of a phrase, choose the word/phrase that best fits in the space, choose the phrase which is a valid expression, or choose the best response to a given phrase.',
              hasTips: false,
              timer: 45
            }
          ],
          timer: {
            isGlobal: false
          }
        }
      ]
    },
    footer: {
      logged: {
        text: 'Bright Language est une marque déposée'
      },
      notlogged: {
        text: 'Bright Language est une marque déposée'
      },
      socials: [
        {
          type: 'youtube',
          link: 'https://www.youtube.com/channel/UCD1qpKpy9_P9zsZdPYuQqUQ'
        }
      ]
    },
    canUpgrade: false,
    training: {
      clever: {
        subtitle:
          'Découvrez la certification BRIGHT Language et augmentez votre niveau pour atteindre votre objectif. Grâce à l’adaptive learning, bénéficiez d’un parcours personnalisé qui s’appuie sur vos bonnes et mauvaises réponses. Choisissez de travailler l’une des parties de l’examen, ou les deux.'
      },
      buildup: {
        subtitle:
          'Votre niveau actuel a dépassé votre objectif mais vous ne trouvez pas encore le courage de vous lancer dans un examen Blanc ? L’entrainement fractionné permet de se mettre dans les conditions de l’examen sur une sélection plus courte de questions. Prenez confiance et augmentez à votre rythme le nombre de questions de votre entrainement.'
      },
      lessons: {
        subtitle:
          'C’est ici que la plateforme vous livre sa connaissance détaillée de votre niveau sur toutes les notions de cours de la plateforme. Montrez lui que vous pouvez passer toutes les notions de cours en leçons « Acquises » !'
      },
      exam: {
        subtitle:
          'Testez-vous dans les conditions de l’examen. Nous vous avons préparé 12 BRIGHT blancs complets conformes à l’examen, pour finaliser vos révisions.'
      }
    },
    mock: {
      graphOptions: {
        ticks: [0, 1, 2, 3, 4, 5]
      }
    },
    scoreHistoricChart: {
      options: {
        scaleSteps: 5,
        scaleStepWidth: 1
      }
    },
    student: {
      home: {
        show_percentage: true,
        show_cecrl: true,
        show_historic: true,
        showExercisesChartExam: 2
      }
    },
    teacher: {
      meanLevelChart: {
        start: 0,
        steps: 0.5,
        max: 5
      }
    },
    login: {
      socialLogin: false,
      canRegister: false,
      canActivate: false
    },
    prefixAssets: 'https://polylearn.fra1.cdn.digitaloceanspaces.com/bright/',
    index: {
      annoucement: false,
      video: false
    }
  },
  linguaskill: {
    name: 'Linguaskill',
    displayName: {
      text: 'Linguaskill',
      trademark: true
    },
    shortName: {
      text: 'Linguaskill',
      trademark: true
    },
    numberOfExams: 13,
    numberOfQuestionsPerExam: 120,
    score: {
      min: 82,
      max: 186,
      step: 1,
      nbAnswers: false
    },
    globalTimer: 5100,
    noPart: true,
    playlistAudio: false,
    part: {
      sections: [
        {
          title: 'Listening',
          id: 'listening',
          parts: [
            {
              id: 1,
              title: 'Listen and select',
              // "help": "Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.",
              // "tips": "Tips part 1",
              directionHTML:
                'For this question, choose the correct answer.<br>Read the question first. Click play to listen. You can listen twice.',
              directionText:
                'For this question, choose the correct answer.<br>Read the question first. Click play to listen. You can listen twice.',
              hasTips: false,
              timer: 60,
              numberOfQuestions: 8
            },
            {
              id: 2,
              title: 'Extended listening',
              // "help": "Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.",
              // "tips": "Tips part 1",
              directionHTML:
                'For these questions, choose the correct answer.<br>Read the question first. Click play to listen. You can listen twice.',
              directionText:
                'For these questions, choose the correct answer.<br>Read the question first. Click play to listen. You can listen twice.',
              hasTips: false,
              timer: 60,
              numberOfQuestions: 24
            }
          ],
          audio: {
            isPlaylist: false
          },
          timer: {
            isGlobal: false
          }
        },
        {
          title: 'Reading',
          id: 'reading',
          parts: [
            {
              id: 3,
              title: 'Read and select',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML: 'For this question, choose the correct answer.',
              directionText: 'For this question, choose the correct answer.',
              hasTips: false,
              timer: 45,
              numberOfQuestions: 4
            },
            {
              id: 4,
              title: 'Gapped sentences',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML: 'Click on the gap then choose the correct answer.',
              directionText: 'Click on the gap then choose the correct answer.',
              hasTips: false,
              timer: 45,
              numberOfQuestions: 4
            },

            {
              id: 5,
              title: 'Multiple-choice gap-fill',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'Click on each gap then choose the correct answer.',
              directionText:
                'Click on each gap then choose the correct answer.',
              hasTips: false,
              timer: 45,
              numberOfQuestions: 20
            },
            {
              id: 6,
              title: 'Open gap-fill',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'For these questions, type the correct answer in each gap.<br>Type only one word in each gap.',
              directionText:
                'For these questions, type the correct answer in each gap.<br>Type only one word in each gap.',
              hasTips: false,
              timer: 45,
              numberOfQuestions: 20
            },
            {
              id: 7,
              title: 'Extended reading',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML: 'For these questions, choose the correct answer.',
              directionText: 'For these questions, choose the correct answer.',
              hasTips: false,
              timer: 45,
              numberOfQuestions: 24
            }
          ],
          timer: {
            isGlobal: false
          }
        }
      ]
    },
    footer: {
      logged: {
        text: 'Linguaskill est une marque déposée'
      },
      notlogged: {
        text: 'Linguaskill est une marque déposée'
      },
      socials: [
        {
          type: 'youtube',
          link: 'https://www.youtube.com/channel/UCD1qpKpy9_P9zsZdPYuQqUQ'
        }
      ]
    },
    canUpgrade: true,
    training: {
      clever: {
        subtitle:
          'Découvrez la certification Linguaskill et augmentez votre niveau pour atteindre votre objectif. Grâce à l’adaptive learning, bénéficiez d’un parcours personnalisé qui s’appuie sur vos bonnes et mauvaises réponses. Choisissez de travailler l’une des parties de l’examen, ou les deux.'
      },
      /*
        "buildup": {
          "subtitle": "Votre niveau actuel a dépassé votre objectif mais vous ne trouvez pas encore le courage de vous lancer dans un examen Blanc ? L’entrainement fractionné permet de se mettre dans les conditions de l’examen sur une sélection plus courte de questions. Prenez confiance et augmentez à votre rythme le nombre de questions de votre entrainement."
        },
        */
      lessons: {
        subtitle:
          'C’est ici que la plateforme vous livre sa connaissance détaillée de votre niveau sur toutes les notions de cours de la plateforme. Montrez lui que vous pouvez passer toutes les notions de cours en leçons « Acquises » !'
      },
      exam: {
        subtitle:
          'Testez-vous dans les conditions de l’examen. Nous vous avons préparé 13 Linguaskill blancs complets conformes à l’examen, pour finaliser vos révisions.'
      }
    },
    mock: {
      graphOptions: {
        low: 60,
        ticks: [80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200]
      }
    },
    scoreHistoricChart: {
      options: {
        scaleSteps: 10,
        scaleStepWidth: 20,
        scaleStartValue: 80
      }
    },
    student: {
      home: {
        show_percentage: true,
        show_cecrl: true,
        show_historic: true,
        showExercisesChartExam: 3
      }
    },
    teacher: {
      meanLevelChart: {
        start: 0,
        steps: 5,
        max: 100
      }
    },
    login: {
      socialLogin: false,
      canRegister: true,
      canActivate: false
    },
    prefixAssets:
      'https://assets-polylearn.fra1.cdn.digitaloceanspaces.com/linguaskill/',
    index: {
      video: false
    }
  },
  toeic: {
    name: 'TOEIC',
    displayName: {
      text: 'TOEIC',
      trademark: true
    },
    shortName: {
      text: 'TOEIC',
      trademark: true
    },
    numberOfExams: 12,
    numberOfQuestionsPerExam: 200,
    score: {
      min: 10,
      max: 990,
      step: 5,
      nbAnswers: false
    },
    playlistAudio: true,
    part: {
      sections: [
        {
          title: 'Listening',
          id: 'listening',
          playlistAudio: true,
          parts: [
            {
              id: 1,
              title: 'Photographs / Photographies',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'For each question in this part, you will hear four statements about a picture in your test book. When you hear the statements, you must select the one statement that best describes what you see in the picture. Then find the number of the question on your answer sheet and mark your answer. The statements will not be printed in your test book and will be spoken only one time.',
              directionText:
                'For each question in this part, you will hear four statements about a picture in your test book. When you hear the statements, you must select the one statement that best describes what you see in the picture. Then find the number of the question on your answer sheet and mark your answer. The statements will not be printed in your test book and will be spoken only one time.',
              hasTips: true,
              numberOfQuestions: 6
            },
            {
              id: 2,
              title: 'Question-Answer / Questions-Réponses',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'You will hear a question or statement and three responses spoken in English. They will not be printed in your test book and will be spoken only one time. Select the best response to the question or statement and mark the letter (A), (B), or (C) on your answer sheet.',
              directionText:
                'You will hear a question or statement and three responses spoken in English. They will not be printed in your test book and will be spoken only one time. Select the best response to the question or statement and mark the letter (A), (B), or (C) on your answer sheet.',
              hasTips: true,
              numberOfQuestions: 25
            },
            {
              id: 3,
              title: 'Short Conversations / Brèves conversations',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'You will hear some conversations between two or more people. You will be asked to answer three questions about what the speakers say in each conversation. Select the best response to each question and mark the letter (A), (B), (C), or (D) on your answer sheet. The conversations will not be printed in your test book and will be spoken only one time.',
              directionText:
                'You will hear some conversations between two or more people. You will be asked to answer three questions about what the speakers say in each conversation. Select the best response to each question and mark the letter (A), (B), (C), or (D) on your answer sheet. The conversations will not be printed in your test book and will be spoken only one time.',
              hasTips: true,
              numberOfQuestions: 39
            },
            {
              id: 4,
              title: 'Short Talks / Monologues',
              help:
                'Dans la 4e partie du test, vous allez entendre des monologues assez longs, et vous devrez répondre à chaque fois à trois questions. Comme dans la 3e partie, l’éventail des sujets est large. Vous pouvez par exemple avoir affaire à une publicité, une offre d’emploi, une annonce à la gare ou à l’aéroport, une émission de radio…',
              tips: 'Tips part 4',
              directionHTML:
                'You will hear some talks given by a single speaker. You will be asked to answer three questions about what the speaker says in each talk. Select the best response to each question and mark the letter (A), (B), (C), or (D) on your answer sheet. The talks will not be printed in your test book and will be spoken only one time.',
              directionText:
                'You will hear some talks given by a single speaker. You will be asked to answer three questions about what the speaker says in each talk. Select the best response to each question and mark the letter (A), (B), (C), or (D) on your answer sheet. The talks will not be printed in your test book and will be spoken only one time.',
              hasTips: true,
              numberOfQuestions: 30
            }
          ]
        },
        {
          title: 'Reading',
          id: 'reading',
          timer: {
            isGlobal: 4500
          },
          parts: [
            {
              id: 5,
              title: 'Incomplete Sentences / Phrases incomplètes',
              help:
                'Cette 5e partie sert à évaluer vos connaissances des fondamentaux de la grammaire anglaise, ainsi que votre vocabulaire. La clef est d’être efficace et rapide lorsque vous choisissez vos réponses.',
              tips: 'Tips part 5',
              directionHTML:
                'A word or phrase is missing in each of the sentences below. Four answer choices are given below each sentence. Select the best answer to complete the sentence. Then mark the letter (A), (B), (C), or (D) on your answer sheet.',
              directionText:
                'A word or phrase is missing in each of the sentences below. Four answer choices are given below each sentence. Select the best answer to complete the sentence. Then mark the letter (A), (B), (C), or (D) on your answer sheet.',
              hasTips: true,
              numberOfQuestions: 30
            },
            {
              id: 6,
              title: 'Text completion / Textes à compléter',
              help:
                'La 6e partie est similaire à la 5e. Vous n’aurez pas des phrases, mais un texte à compléter – c’est donc un peu plus long. Quatre propositions vous sont données, qui font appel à vos connaissances en grammaire et en vocabulaire, avec des pièges. Il faut choisir l’unique solution correcte.',
              tips: 'Tips part 6',
              directionHTML:
                'Read the texts that follow. A word, phrase, or sentence is missing in parts of each text. Four answer choices for each question are given below the text. Select the best answer to complete the text. Then mark the letter (A), (B), (C), or (D) on your answer sheet.',
              directionText:
                'Read the texts that follow. A word, phrase, or sentence is missing in parts of each text. Four answer choices for each question are given below the text. Select the best answer to complete the text. Then mark the letter (A), (B), (C), or (D) on your answer sheet.',
              hasTips: true,
              numberOfQuestions: 16
            },
            {
              id: 7,
              title: 'Reading comprehension / Compréhension de textes écrits',
              help:
                'Vous arrivez à la fin du test, mais il ne faut pas vous relâcher pour autant car ce n’est pas la section la plus facile ! Les textes sont plus longs. Certains sont « simples » avec deux ou trois questions par texte, et d’autres « doubles » (par exemple un e-mail avec une réponse, un tableau avec un mémo…) avec cinq questions – soit 28 questions au total.',
              tips: 'Tips part 7',
              directionHTML:
                'In this part you will read a selection of texts, such as magazine and newspaper articles, e-mails, and instant messages. Each text or set of texts is followed by several questions. Select the best answer for each question and mark the letter (A), (B), (C), or (D) on your answer sheet.',
              directionText:
                'In this part you will read a selection of texts, such as magazine and newspaper articles, e-mails, and instant messages. Each text or set of texts is followed by several questions. Select the best answer for each question and mark the letter (A), (B), (C), or (D) on your answer sheet.',
              hasTips: true,
              numberOfQuestions: 54
            }
          ]
        }
      ]
    },
    footer: {
      logged: {
        text:
          'TOEIC® est une marque déposée de Educational Testing Service(ETS®).<br>ETS® décline toute responsabilité quant à la publication et au contenu de cet ouvrage.'
      },
      notlogged: {
        text:
          'TOEIC® est une marque déposée de Educational Testing Service(ETS®). ETS® décline toute responsabilité quant à la publication et au contenu de cet ouvrage.'
      },
      socials: [
        {
          type: 'youtube',
          link: 'https://www.youtube.com/channel/UCD1qpKpy9_P9zsZdPYuQqUQ'
        }
      ]
    },
    canUpgrade: true,
    training: {
      clever: {
        subtitle:
          'Découvrez comment fonctionne l’examen du <cf-exam-name></cf-exam-name> à l’aide des TIPS. Grâce à l’adaptive learning, bénéficiez d’un parcours personnalisé qui s’appuie sur vos erreurs. Optimisez votre score sur les 7 parties du <cf-exam-name></cf-exam-name>.'
      },
      buildup: {
        subtitle:
          'L’objectif de cet entraînement est de vous aider à augmenter votre capacité de concentration, afin de pouvoir finir l’examen en temps et en heure.'
      },
      lessons: {
        subtitle:
          'Vous souhaitez cibler les cours qui vous posent problème, cet entraînement est fait pour vous.'
      },
      exam: {
        subtitle:
          'Testez-vous dans les conditions de l’examen. Nous vous avons préparé 12 TOEIC® blancs complets conformes à l’examen, pour finaliser vos révisions.'
      }
    },
    mock: {
      graphOptions: {}
    },
    scoreHistoricChart: {
      options: {
        scaleSteps: 10,
        scaleStepWidth: 100
      }
    },
    student: {
      home: {
        show_percentage: true,
        show_cecrl: false,
        show_historic: true,
        showExercisesChartExam: 3
      }
    },
    teacher: {
      meanLevelChart: {
        start: 0,
        steps: 50,
        max: 1000
      }
    },
    login: {
      socialLogin: true,
      canRegister: true,
      canActivate: true
    },
    prefixAssets: 'https://assets-polylearn.fra1.cdn.digitaloceanspaces.com',
    index: {
      video: true
    }
  },
  lerobert: {
    name: 'Le Robert',
    displayName: {
      text: 'Le Robert',
      trademark: false
    },
    shortName: {
      text: 'Le Robert',
      trademark: false
    },
    numberOfExams: 6,
    score: {
      min: 0,
      max: 1000,
      step: 50,
      nbAnswers: false
    },
    playlistAudio: false,
    part: {
      sections: [
        {
          title: 'Modules',
          id: 'reading',
          playlistAudio: false,
          parts: [
            {
              id: 1,
              timer: 45,
              title: 'Genre des noms',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML: 'Sélectionnez le genre du nom ci-dessous.',
              directionText: 'Sélectionnez le genre du nom ci-dessous.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Orthographe'
            },
            {
              id: 2,
              timer: 45,
              title: 'Sens des mots et des expressions',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'Sélectionnez le sens correspondant au mot ou à l’expression ci-dessous.',
              directionText:
                'Sélectionnez le sens correspondant au mot ou à l’expression ci-dessous.',
              hasTips: false,
              numberOfQuestions: 29,
              subCategory: 'Vocabulaire et expression'
            },
            {
              id: 3,
              timer: 45,
              title: 'Dictée',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Écrivez le mot ou l’expression que vous entendez.<br/> Mettez les noms au singulier, les adjectifs au masculin singulier, les verbes à l’infinitif et les nombres en toutes lettres.<br/> Les orthographes traditionnelles et rectifiées sont acceptées.',
              directionText:
                'Écrivez le mot ou l’expression que vous entendez. Mettez les noms au singulier, les adjectifs au masculin singulier, les verbes à l’infinitif et les nombres en toutes lettres. Les orthographes traditionnelles et rectifiées sont acceptées.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Orthographe'
            },
            {
              id: 4,
              timer: 45,
              title: 'Homophones',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Complétez la phrase ci-dessous par l’un des mots ou groupes de mots ci-dessous',
              directionText:
                'Complétez la phrase ci-dessous par l’un des mots ou groupes de mots ci-dessous',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Orthographe'
            },
            {
              id: 5,
              timer: 45,
              title: 'Pluriel des noms et des adjectifs',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Écrivez le mot ci-dessous au pluriel.',
              directionText: 'Écrivez le mot ci-dessous au pluriel.',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Orthographe'
            },
            {
              id: 6,
              timer: 45,
              title: 'Féminin des noms et des adjectifs',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Écrivez le mot ci-dessous au féminin.',
              directionText: 'Écrivez le mot ci-dessous au féminin.',
              hasTips: true,
              numberOfQuestions: 10,
              subCategory: 'Orthographe'
            },
            {
              id: 7,
              timer: 45,
              title: 'Accord dans le groupe nominal',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Complétez la phrase à l’aide du mot ci-dessous, en l’accordant si nécessaire.',
              directionText:
                'Complétez la phrase à l’aide du mot ci-dessous, en l’accordant si nécessaire.',
              hasTips: true,
              numberOfQuestions: 25,
              subCategory: 'Grammaire'
            },
            {
              id: 8,
              timer: 45,
              title: 'Pronoms relatifs',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Complétez la phrase par l’un des pronoms relatifs suivants : <i>lequel</i>, <i>auquel</i>, <i>duquel</i>, <i>dont</i>, <i>où</i>, <i>que</i>, <i>qui</i>. Accordez-le, si nécessaire.',
              directionText:
                'Complétez la phrase par l’un des pronoms relatifs suivants : lequel, auquel, duquel, dont, où, que, qui. Accordez-le, si nécessaire.',
              hasTips: true,
              numberOfQuestions: 8,
              subCategory: 'Grammaire'
            },
            {
              id: 9,
              timer: 45,
              title: 'Conjugaison',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Complétez le tableau de conjugaison ci-dessous.',
              directionText: 'Complétez le tableau de conjugaison ci-dessous.',
              hasTips: true,
              numberOfQuestions: 20,
              subCategory: 'Conjugaison'
            },
            {
              id: 10,
              timer: 45,
              title: 'Accord dans le groupe verbal',
              help:
                'Dans la 4e partie du test, vous allez entendre des monologues assez longs, et vous devrez répondre à chaque fois à trois questions. Comme dans la 3e partie, l’éventail des sujets est large. Vous pouvez par exemple avoir affaire à une publicité, une offre d’emploi, une annonce à la gare ou à l’aéroport, une émission de radio…',
              tips: 'Tips part 4',
              directionHTML:
                'Complétez la phrase en conjuguant le verbe ci-dessous au présent de l’indicatif.',
              directionText:
                'Complétez la phrase en conjuguant le verbe ci-dessous au présent de l’indicatif.',
              hasTips: true,
              numberOfQuestions: 20,
              subCategory: 'Grammaire'
            },
            {
              id: 11,
              timer: 45,
              title: 'Concordance des temps',
              help:
                'Dans la 4e partie du test, vous allez entendre des monologues assez longs, et vous devrez répondre à chaque fois à trois questions. Comme dans la 3e partie, l’éventail des sujets est large. Vous pouvez par exemple avoir affaire à une publicité, une offre d’emploi, une annonce à la gare ou à l’aéroport, une émission de radio…',
              tips: 'Tips part 4',
              directionHTML:
                'Complétez la phrase en conjuguant le verbe ci-dessous au mode, au temps et à la personne appropriés.',
              directionText:
                'Complétez la phrase en conjuguant le verbe ci-dessous au mode, au temps et à la personne appropriés.',
              hasTips: true,
              numberOfQuestions: 15,
              subCategory: 'Conjugaison'
            },
            {
              id: 12,
              timer: 45,
              title: 'Accord du participe passé',
              help:
                'Dans la 4e partie du test, vous allez entendre des monologues assez longs, et vous devrez répondre à chaque fois à trois questions. Comme dans la 3e partie, l’éventail des sujets est large. Vous pouvez par exemple avoir affaire à une publicité, une offre d’emploi, une annonce à la gare ou à l’aéroport, une émission de radio…',
              tips: 'Tips part 4',
              directionHTML:
                'Complétez la phrase avec le participe passé ci-dessous. Accordez-le, si nécessaire.',
              directionText:
                'Complétez la phrase avec le participe passé ci-dessous. Accordez-le, si nécessaire.',
              hasTips: true,
              numberOfQuestions: 29,
              subCategory: 'Grammaire'
            },
            {
              id: 13,
              timer: 45,
              title: 'Orthographe',
              help:
                'Dans la 4e partie du test, vous allez entendre des monologues assez longs, et vous devrez répondre à chaque fois à trois questions. Comme dans la 3e partie, l’éventail des sujets est large. Vous pouvez par exemple avoir affaire à une publicité, une offre d’emploi, une annonce à la gare ou à l’aéroport, une émission de radio…',
              tips: 'Tips part 4',
              directionHTML:
                'Si vous pensez que la phrase ci-dessous contient une erreur orthographique, sélectionnez <i>La phrase n’est pas correcte</i> et corrigez-la ; sinon, sélectionnez <i>La phrase est correcte</i>. <br/>Il ne peut pas y avoir plus d’une erreur par phrase.',
              directionText:
                'Si vous pensez que la phrase ci-dessous contient une erreur orthographique, sélectionnez La phrase n’est pas correcte et corrigez-la ; sinon, sélectionnez La phrase est correcte. Il ne peut pas y avoir plus d’une erreur par phrase.',
              hasTips: true,
              numberOfQuestions: 39,
              subCategory: 'Orthographe'
            },
            {
              id: 14,
              timer: 45,
              title: 'Construction des phrases',
              help:
                'Dans la 4e partie du test, vous allez entendre des monologues assez longs, et vous devrez répondre à chaque fois à trois questions. Comme dans la 3e partie, l’éventail des sujets est large. Vous pouvez par exemple avoir affaire à une publicité, une offre d’emploi, une annonce à la gare ou à l’aéroport, une émission de radio…',
              tips: 'Tips part 4',
              directionHTML:
                'Si vous pensez que la phrase ci-dessous est mal construite, sélectionnez <i>La phrase n’est pas correcte</i> et corrigez-la ; sinon, sélectionnez <i>La phrase est correcte</i>. <br/>Il ne peut pas y avoir plus d’une erreur par phrase.',
              directionText:
                'Si vous pensez que la phrase ci-dessous est mal construite, sélectionnez La phrase n’est pas correcte et corrigez-la ; sinon, sélectionnez La phrase est correcte. Il ne peut pas y avoir plus d’une erreur par phrase.',
              hasTips: true,
              numberOfQuestions: 18,
              subCategory: 'Grammaire'
            },
            {
              id: 15,
              timer: 45,
              title: 'Paronymes et pléonasmes',
              help:
                'Dans la 4e partie du test, vous allez entendre des monologues assez longs, et vous devrez répondre à chaque fois à trois questions. Comme dans la 3e partie, l’éventail des sujets est large. Vous pouvez par exemple avoir affaire à une publicité, une offre d’emploi, une annonce à la gare ou à l’aéroport, une émission de radio…',
              tips: 'Tips part 4',
              directionHTML:
                'Si vous pensez que la phrase ci-dessous contient un paronyme (mot employé pour un autre) ou un pléonasme (répétition de sens), sélectionnez <i>La phrase n’est pas correcte</i> et corrigez-la ; sinon, sélectionnez <i>La phrase est correcte</i>. <br/>Il ne peut pas y avoir plus d’une erreur par phrase.',
              directionText:
                'Si vous pensez que la phrase ci-dessous contient un paronyme (mot employé pour un autre) ou un pléonasme (répétition de sens), sélectionnez La phrase n’est pas correcte et corrigez-la ; sinon, sélectionnez La phrase est correcte. <br/>Il ne peut pas y avoir plus d’une erreur par phrase.',
              hasTips: true,
              numberOfQuestions: 18,
              subCategory: 'Vocabulaire et expression'
            },
            {
              id: 16,
              timer: 45,
              title: 'Registres de langue',
              help:
                'Dans la 4e partie du test, vous allez entendre des monologues assez longs, et vous devrez répondre à chaque fois à trois questions. Comme dans la 3e partie, l’éventail des sujets est large. Vous pouvez par exemple avoir affaire à une publicité, une offre d’emploi, une annonce à la gare ou à l’aéroport, une émission de radio…',
              tips: 'Tips part 4',
              directionHTML: `Si vous pensez que la phrase ci-dessous contient un mot ou une expression de la langue familière, sélectionnez <i>La phrase n’est pas correcte</i> et corrigez-la ; sinon, sélectionnez <i>La phrase est correcte</i>. <br/>Il ne peut pas y avoir plus d’une erreur par phrase.`,
              directionText:
                'Si vous pensez que la phrase ci-dessous contient un mot ou une expression de la langue familière, sélectionnez La phrase n’est pas correcte et corrigez-la ; sinon, sélectionnez La phrase est correcte. Il ne peut pas y avoir plus d’une erreur par phrase.',
              hasTips: true,
              numberOfQuestions: 9,
              subCategory: 'Vocabulaire et expression'
            }
          ]
        }
      ]
    },
    footer: {
      logged: {
        text: 'Une formation Le Robert propulsée par Polylearn'
      },
      notlogged: {
        text: 'Le Robert® est une marque déposée'
      },
      socials: [
        {
          type: 'youtube',
          link: 'https://www.youtube.com/user/EditionsRobert'
        },
        {
          type: 'facebook',
          link: 'https://www.facebook.com/EditionsRobert/'
        },
        {
          type: 'twitter',
          link: 'https://twitter.com/LeRobert_com'
        },
        {
          type: 'linkedin',
          link: 'https://www.linkedin.com/company/dictionnaires-le-robert'
        },
        {
          type: 'instagram',
          link: 'https://www.instagram.com/lerobert_com/'
        }
      ]
    },
    canUpgrade: false,
    training: {
      clever: {
        subtitle:
          '16 modules d’entraînement vous sont proposés afin de vous aider à atteindre votre objectif.'
      },
      buildup: {
        subtitle:
          'L’objectif de cet entraînement est de vous aider à augmenter votre capacité de concentration, afin de réussir au mieux la <i>Certification Le Robert</i>.'
      },
      /*
      "lessons": {
        "subtitle": "Vous souhaitez cibler les cours qui vous posent problème, cet entraînement est fait pour vous."
      },
      */
      exam: {
        subtitle:
          'Entraînez-vous en conditions réelles sur les 6 tests blancs de la Certification Le Robert que nous vous avons préparés.'
      }
    },
    mock: {
      graphOptions: {}
    },
    scoreHistoricChart: {
      options: {
        scaleSteps: 10,
        scaleStepWidth: 100
      }
    },
    student: {
      home: {
        show_percentage: true,
        show_cecrl: false,
        show_historic: true,
        showExercisesChartExam: 3
      }
    },
    teacher: {
      meanLevelChart: {
        start: 0,
        steps: 50,
        max: 1000
      }
    },
    login: {
      socialLogin: false,
      canRegister: false,
      canActivate: false
    },
    prefixAssets: 'https://polylearn.b-cdn.net/lerobert/',
    index: {
      video: false
    }
  },
  delf: {
    name: 'DELF',
    displayName: {
      text: 'DELF',
      trademark: false
    },
    shortName: {
      text: 'DELF',
      trademark: false
    },
    numberOfExams: 6,
    score: {
      min: 0,
      max: 100,
      step: 1,
      nbAnswers: false
    },
    globalTimer: 12000, // 3h20
    playlistAudio: false,
    part: {
      sections: [
        {
          title: 'Modules',
          id: 'reading',
          playlistAudio: false,
          timer: {
            isGlobal: 12000
          },
          parts: [
            {
              id: 1,
              timer: 45,
              level: 'B2',
              title: 'Compréhension de l’oral - Exercice 1',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },
            {
              id: 2,
              timer: 45,
              level: 'B2',
              title: 'Compréhension de l’oral - Exercice 2',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 3,
              timer: 45,
              level: 'B2',
              title: 'Compréhension de l’oral - Exercice 3',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'Vous allez écouter 1 fois 3 documents. Lisez les questions. Écoutez le document. Pour chaque question, cochez (x) la bonne réponse.',
              directionText:
                'Vous allez écouter 1 fois 3 documents. Lisez les questions. Écoutez le document. Pour chaque question, cochez (x) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 29,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 4,
              timer: 45,
              level: 'B2',
              title: 'Compréhension des écrits - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Répondez aux questions en cochant (✗) la bonne réponse.',
              directionText:
                'Répondez aux questions en cochant (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 5,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 2',
              level: 'B2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              directionText:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 6,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 3',
              level: 'B2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'À quelle personne associez-vous chaque point de vue ? Pour chaque affirmation, cochez (x) a bonne réponse.',
              directionText:
                'À quelle personne associez-vous chaque point de vue ? Pour chaque affirmation, cochez (x) a bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 7,
              level: 'B2',
              timer: 60 * 50,
              title: 'Production orale',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Vous dégagerez le problème soulevé par le document ci-dessous. Vous présenterez votre opinion sur le sujet de manière argumentée et vous la défendrez si nécessaire.',
              directionText:
                'Vous dégagerez le problème soulevé par le document ci-dessous. Vous présenterez votre opinion sur le sujet de manière argumentée et vous la défendrez si nécessaire.',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },
            {
              id: 8,
              level: 'B2',
              timer: 60 * 60,
              title: 'Production écrite',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Rédigez un article argumenté de 250 mots environ.',
              directionText:
                'Rédigez un article argumenté de 250 mots environ.',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production écrite',
              score: 'writing_score'
            },

            {
              id: 1,
              timer: 45,
              level: 'B1',
              title: 'Compréhension de l’oral - Exercice 1',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },
            {
              id: 2,
              timer: 45,
              level: 'B1',
              title: 'Compréhension de l’oral - Exercice 2',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 3,
              timer: 45,
              level: 'B1',
              title: 'Compréhension de l’oral - Exercice 3',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 29,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 4,
              timer: 45,
              level: 'B1',
              title: 'Compréhension des écrits - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Cochez ([x]) OUI si cela correspond au critère ou NON si cela ne correspond pas.',
              directionText:
                'Cochez ([x]) OUI si cela correspond au critère ou NON si cela ne correspond pas.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 5,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 2',
              level: 'B1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              directionText:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 6,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 3',
              level: 'B1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              directionText:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 7,
              level: 'B1',
              timer: 60 * 3,
              title: 'Production orale - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                ' Présentez-vous : parlez de vos activités, de vos centres d’intérêt, de vos projets…',
              directionText:
                ' Présentez-vous : parlez de vos activités, de vos centres d’intérêt, de vos projets…',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },

            {
              id: 8,
              level: 'B1',
              timer: 60 * 4,
              title: 'Production orale - Exercice 2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: '',
              directionText: '',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },

            {
              id: 9,
              level: 'B1',
              timer: 15 * 50,
              title: 'Production orale - Exercice 3',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: '',
              directionText: '',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },

            {
              id: 10,
              level: 'B1',
              timer: 60 * 60,
              title: 'Production écrite',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Rédigez un texte argumenté de 160 mots minimum.',
              directionText: 'Rédigez un texte argumenté de 160 mots minimum.',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production écrite',
              score: 'writing_score'
            },

            {
              id: 1,
              timer: 45,
              level: 'B1-JR',
              title: 'Compréhension de l’oral - Exercice 1',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },
            {
              id: 2,
              timer: 45,
              level: 'B1-JR',
              title: 'Compréhension de l’oral - Exercice 2',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 3,
              timer: 45,
              level: 'B1-JR',
              title: 'Compréhension de l’oral - Exercice 3',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 29,
              subCategory: 'Compréhension de l’oral'
            },
            {
              id: 4,
              timer: 45,
              level: 'B1-JR',
              title: 'Compréhension des écrits - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Cochez ([x]) OUI si cela correspond au critère ou NON si cela ne correspond pas.',
              directionText:
                'Cochez ([x]) OUI si cela correspond au critère ou NON si cela ne correspond pas.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },
            {
              id: 5,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 2',
              level: 'B1-JR',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              directionText:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },
            {
              id: 6,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 3',
              level: 'B1-JR',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              directionText:
                'Répondez aux questions en cochant (x) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },
            {
              id: 7,
              level: 'B1-JR',
              timer: 60 * 3,
              title: 'Production orale - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                ' Présentez-vous : parlez de vos activités, de vos centres d’intérêt, de vos projets…',
              directionText:
                ' Présentez-vous : parlez de vos activités, de vos centres d’intérêt, de vos projets…',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },
            {
              id: 8,
              level: 'B1-JR',
              timer: 60 * 4,
              title: 'Production orale - Exercice 2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: '',
              directionText: '',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },
            {
              id: 9,
              level: 'B1-JR',
              timer: 15 * 50,
              title: 'Production orale - Exercice 3',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: '',
              directionText: '',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },
            {
              id: 10,
              level: 'B1-JR',
              timer: 60 * 60,
              title: 'Production écrite',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Rédigez un texte argumenté de 160 mots minimum.',
              directionText: 'Rédigez un texte argumenté de 160 mots minimum.',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production écrite',
              score: 'writing_score'
            },

            {
              id: 1,
              timer: 45,
              level: 'B2-JR',
              title: 'Compréhension de l’oral - Exercice 1',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },
            {
              id: 2,
              timer: 45,
              level: 'B2-JR',
              title: 'Compréhension de l’oral - Exercice 2',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez (✗) la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 3,
              timer: 45,
              level: 'B2-JR',
              title: 'Compréhension de l’oral - Exercice 3',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez la bonne réponse.',
              directionText:
                'Lisez les questions. Écoutez le document. Pour chaque question, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 29,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 4,
              timer: 45,
              level: 'B2-JR',
              title: 'Compréhension des écrits - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Répondez aux questions en cochant la bonne réponse.',
              directionText:
                'Répondez aux questions en cochant la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 5,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 2',
              level: 'B2-JR',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Répondez aux questions en cochant la bonne réponse.',
              directionText:
                'Répondez aux questions en cochant la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 6,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 3',
              level: 'B2-JR',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'À quelle personne associez-vous chaque point de vue ? Pour chaque affirmation, cochez a bonne réponse.',
              directionText:
                'À quelle personne associez-vous chaque point de vue ? Pour chaque affirmation, cochez a bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 7,
              level: 'B2-JR',
              timer: 60 * 50,
              title: 'Production orale',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Vous dégagerez le problème soulevé par le document ci-dessous. Vous présenterez votre opinion sur le sujet de manière argumentée et vous la défendrez si nécessaire.',
              directionText:
                'Vous dégagerez le problème soulevé par le document ci-dessous. Vous présenterez votre opinion sur le sujet de manière argumentée et vous la défendrez si nécessaire.',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },
            {
              id: 8,
              level: 'B2-JR',
              timer: 60 * 60,
              title: 'Production écrite',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Rédigez un texte argumenté de 250 mots environ.',
              directionText: 'Rédigez un texte argumenté de 250 mots environ.',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production écrite',
              score: 'writing_score'
            },

            {
              id: 1,
              timer: 45,
              title: 'Compréhension de l’oral - Exercice 1',
              level: 'A2',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },
            {
              id: 2,
              timer: 45,
              title: 'Compréhension de l’oral - Exercice 2',
              level: 'A2',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse. ',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse. ',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 3,
              timer: 45,
              level: 'A2',
              title: 'Compréhension de l’oral - Exercice 3',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse. ',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse. ',
              hasTips: false,
              numberOfQuestions: 29,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 4,
              timer: 45,
              level: 'A2',
              title: 'Compréhension de l’oral - Exercice 4',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 5,
              timer: 45,
              level: 'A2',
              title: 'Compréhension des écrits - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 6,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 2',
              level: 'A2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 7,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 3',
              level: 'A2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 8,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 4',
              level: 'A2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 9,
              level: 'A2',
              timer: 60 * 50,
              title: 'Production orale - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Vous vous exprimez sur le sujet.',
              directionText: 'Vous vous exprimez sur le sujet.',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },
            {
              id: 10,
              level: 'A2',
              timer: 60 * 60,
              title: 'Production orale - Exercice 2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Vous simulez un dialogue avec l’examinateur afin de résoudre une situation de la vie quotidienne. ',
              directionText:
                'Vous simulez un dialogue avec l’examinateur afin de résoudre une situation de la vie quotidienne. ',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production orale',
              score: 'oral_score'
            },

            {
              id: 11,
              level: 'A2',
              timer: 60 * 60,
              title: 'Production écrite - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Écrivez un texte de 60 mots minimum.',
              directionText: 'Écrivez un texte de 60 mots minimum.',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production écrite',
              score: 'writing_score'
            },

            {
              id: 12,
              level: 'A2',
              timer: 60 * 60,
              title: 'Production écrite - Exercice 2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Écrivez un texte de 60 mots minimum.',
              directionText: 'Écrivez un texte de 60 mots minimum.',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production écrite',
              score: 'writing_score'
            },

            {
              id: 1,
              timer: 45,
              title: 'Compréhension de l’oral - Exercice 1',
              level: 'A2-JR',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Vous écoutez des annonces publiques. Lisez les questions. Écoutez les documents puis répondez.',
              directionText:
                'Vous écoutez des annonces publiques. Lisez les questions. Écoutez les documents puis répondez.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },
            {
              id: 2,
              timer: 45,
              title: 'Compréhension de l’oral - Exercice 2',
              level: 'A2-JR',
              help:
                'Dans cette partie, pensez avant tout à bien regarder la photo. Vous allez entendre 4 phrases et devrez choisir la plus adaptée à la situation. Vous devez donc être capable de faire deux choses à la fois : écouter les réponses ET regarder les photos.',
              tips: 'Tips part 1',
              directionHTML:
                'Vous écoutez la radio. Lisez les questions. Écoutez les documents puis répondez.',
              directionText:
                'Vous écoutez la radio. Lisez les questions. Écoutez les documents puis répondez.',
              hasTips: false,
              numberOfQuestions: 15,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 3,
              timer: 45,
              level: 'A2-JR',
              title: 'Compréhension de l’oral - Exercice 3',
              help:
                'La deuxième partie de l’épreuve consiste en une question ou phrase déclarative, suivie de 3 réponses, le tout en anglais. Il faut choisir la bonne réponse parmi les trois proposées. Rien n’est écrit, tout se passe à l’oral.',
              tips: 'Tips part 2',
              directionHTML:
                'Vous écoutez ce message sur un répondeur téléphonique. Lisez les questions. Écoutez les documents puis répondez.',
              directionText:
                'Vous écoutez ce message sur un répondeur téléphonique. Lisez les questions. Écoutez les documents puis répondez.',
              hasTips: false,
              numberOfQuestions: 29,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 4,
              timer: 45,
              level: 'A2-JR',
              title: 'Compréhension de l’oral - Exercice 4',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Vous écoutez 4 dialogues. Cochez pour associer chaque dialogue à la situation correspondante.<br>Attention : il y a 6 situations, mais seulement 4 dialogues.<br>Lisez les situations. Écoutez les dialogues puis répondez.',
              directionText:
                'Vous écoutez 4 dialogues. Cochez pour associer chaque dialogue à la situation correspondante. Attention : il y a 6 situations, mais seulement 4 dialogues. Lisez les situations. Écoutez les dialogues puis répondez.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension de l’oral'
            },

            {
              id: 5,
              timer: 45,
              level: 'A2-JR',
              title: 'Compréhension des écrits - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 6,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 2',
              level: 'A2-JR',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 7,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 3',
              level: 'A2-JR',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 8,
              timer: 45,
              title: 'Compréhension des écrits - Exercice 4',
              level: 'A2-JR',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Pour répondre aux questions, cochez la bonne réponse.',
              directionText:
                'Pour répondre aux questions, cochez la bonne réponse.',
              hasTips: false,
              numberOfQuestions: 36,
              subCategory: 'Compréhension des écrits'
            },

            {
              id: 9,
              level: 'A2-JR',
              timer: 60 * 50,
              title: 'Production orale - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Vous vous exprimez sur le sujet.',
              directionText: 'Vous vous exprimez sur le sujet.',
              hasTips: true,
              numberOfQuestions: 40,
              subCategory: 'Production orale',
              score: 'oral_score'
            },
            {
              id: 10,
              level: 'A2-JR',
              timer: 60 * 60,
              title: 'Production orale - Exercice 2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML:
                'Vous simulez un dialogue avec l’examinateur afin de résoudre une situation de la vie quotidienne. ',
              directionText:
                'Vous simulez un dialogue avec l’examinateur afin de résoudre une situation de la vie quotidienne. ',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production orale',
              score: 'oral_score'
            },

            {
              id: 11,
              level: 'A2-JR',
              timer: 60 * 60,
              title: 'Production écrite - Exercice 1',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Écrivez un texte de 60 mots minimum.',
              directionText: 'Écrivez un texte de 60 mots minimum.',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production écrite',
              score: 'writing_score'
            },

            {
              id: 12,
              level: 'A2-JR',
              timer: 60 * 60,
              title: 'Production écrite - Exercice 2',
              help:
                'Dans la 3e partie, on entend une conversation. Ensuite, sont posées par écrit trois questions sur ce dialogue, chacune avec quatre propositions de réponse. Une seule est juste !',
              tips: 'Tips part 3',
              directionHTML: 'Écrivez un texte de 60 mots minimum.',
              directionText: 'Écrivez un texte de 60 mots minimum.',
              hasTips: true,
              numberOfQuestions: 19,
              subCategory: 'Production écrite',
              score: 'writing_score'
            }
          ]
        }
      ]
    },
    footer: {
      logged: {
        text: ''
      },
      notlogged: {
        text: 'CLE International est une marque déposée'
      },
      socials: [
        {
          type: 'facebook',
          link: 'https://www.facebook.com/groups/257865919553944'
        }
      ]
    },
    canUpgrade: false,
    training: {
      clever: {
        subtitle: {
          fr:
            '8 modules d’entraînement vous sont proposés afin de vous aider à atteindre votre objectif.',
          en: '8 training modules are available to help you reach your goal.'
        }
      },
      /*
      "buildup": {
        "subtitle": "L’objectif de cet entraînement est de vous aider à augmenter votre capacité de concentration, afin de réussir au mieux la <i>Certification Le Robert</i>."
      },
      */
      lessons: {
        // "subtitle": "Entrainez-vous avec les exercices suivants afin de vous aider à atteindre votre objectif.",
        exercisesDisplay: true
      },
      exam: {
        subtitle: {
          fr: 'Entraînez-vous en conditions réelles sur 43 épreuves blanches.',
          en: 'Train in real conditions on 43 mock exams.'
        }
      }
    },
    mock: {
      graphOptions: {}
    },
    scoreHistoricChart: {
      options: {
        scaleSteps: 10,
        scaleStepWidth: 10
      }
    },
    student: {
      home: {
        show_percentage: true,
        show_cecrl: false,
        show_historic: true,
        showExercisesChartExam: 3
      }
    },
    teacher: {
      meanLevelChart: {
        start: 0,
        steps: 10,
        max: 100
      }
    },
    login: {
      socialLogin: false,
      canRegister: false,
      canActivate: false
    },
    prefixAssets: 'https://polylearn.b-cdn.net/delf/',
    index: {
      video: false
    }
  }
};
